import { render } from "./WeightBarnSection.vue?vue&type=template&id=64dadf10&ts=true"
import script from "./WeightBarnSection.vue?vue&type=script&lang=ts"
export * from "./WeightBarnSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__